import React from 'react';
import { MapPin } from 'lucide-react';
const CITIES = ['Huntsville', 'Conroe', 'The Woodlands', 'Spring', 'Houston', 'Sugar Land', 'Katy', 'Pearland', 'League City', 'Texas City', 'Galveston'];
export function ServiceArea() {
  return <section id="service-area" className="py-24 bg-dark relative overflow-hidden" data-id="element-206">
      <div className="absolute inset-0 opacity-5 pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#dc2626 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-207" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-208">
        <div className="max-w-4xl mx-auto bg-surface rounded-2xl border border-accent/20 p-8 md:p-12 shadow-2xl flex flex-col md:flex-row items-center gap-12" data-id="element-209">
          <div className="flex-1 text-center md:text-left" data-id="element-210">
            <div className="inline-flex items-center gap-2 text-accent-light font-bold uppercase tracking-wider mb-4" data-id="element-211">
              <MapPin className="h-5 w-5" data-id="element-212" />
              Huntsville to Galveston
            </div>
            <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-6" data-id="element-213">
              Serving <span className="text-accent" data-id="element-214">Southeast Texas</span>
            </h2>
            <p className="text-slate-400 text-lg mb-8" data-id="element-215">
              We bring our expert plumbing services directly to your doorstep
              across the greater Houston area and beyond.
            </p>
            <div className="flex flex-wrap justify-center md:justify-start gap-3" data-id="element-216">
              {CITIES.map(city => <span key={city} className="px-4 py-2 rounded-full bg-dark border border-accent/30 text-slate-300 text-sm font-medium" data-id="element-217">
                  {city}
                </span>)}
            </div>
          </div>

          <div className="w-full md:w-1/2 flex justify-center" data-id="element-218">
            <div className="relative w-full aspect-square max-w-sm rounded-full overflow-hidden border-4 border-accent/20 shadow-[0_0_50px_rgba(220,38,38,0.2)]" data-id="element-219">
              <img src="https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?q=80&w=800&auto=format&fit=crop" alt="Modern bathroom sink and faucet fixture" className="w-full h-full object-cover" data-id="element-220" />
              <div className="absolute inset-0 bg-dark/20" data-id="element-221" />
              <MapPin className="h-16 w-16 text-accent-light absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 drop-shadow-lg" data-id="element-222" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}